module.exports = __webpack_public_path__ + "static/media/Plus.0f548a60.svg";